import React from 'react'
import './contact.css'
import { translate } from 'react-i18next'
import ReactCSSTransitionGroup from 'react-addons-css-transition-group'

import ButtonLeft from './ButtonLeft'
import { LocationSvg, TelSvg, MailSvg } from './SVGarr'

const Contact = (props) => {
  return(
    <ReactCSSTransitionGroup
    transitionName="imgTransition"
    transitionAppear={true}
    transitionAppearTimeout={500}
    transitionEnter={false}
    transitionLeave={false}>
      <div className="contact">
        <div className="contactTop"> <ButtonLeft url='/'/> <div>{props.t('locationW')}</div> </div>
        <div className="prise">
          {LocationSvg} {props.t('location')}
          <a href='tel:+380974690628'> {TelSvg} +38 097 469 06 28 </a>
          <a href='tel:+380663138105'> {TelSvg} +38 066 313 81 05 Telegram Viber </a>
          <a href='mailto:vazonstudia@gmail.com'> {MailSvg} vazonstudia@gmail.com </a>
        </div>
        <iframe title="Карта" src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d2017.1899196266145!2d30.63189604249318!3d50.4317866537701!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0xe22c155b778938eb!2sMega-City!5e0!3m2!1sru!2sua!4v1533402863269"></iframe>
      </div>
    </ReactCSSTransitionGroup>
  )
}

export default translate('translations')(Contact)


// WEBPACK FOOTER //
// ./src/components/contact.jsx